<select (change)="onIsoChange($event)"
    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-primary-500 w-full ease-linear transition-all duration-150">
    <option *ngFor="let item of countryList | async as list" [selected]="selectedCode == item.code" [value]="item.code">
        {{item.emoji}} {{item.name}}</option>
    <option [selected]="selectedCode == 'unknown'" value="unknown">Unknown</option>
</select>
<div class="pt-1 h-6 text-red-500 text-xs">
    <p *ngIf="selectedCode == 'unknown'">Value is required</p>
</div>